import { TextButton } from 'ui/button';
import { CampaignsErrorState } from 'ui/illustrations';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const GeneralErrorState = () => (
  <PlaceholderState
    Illustration={CampaignsErrorState}
    title="Oops! Issue loading campaigns"
    data-test="campaign-index-general-error-state"
  >
    We&apos;re having trouble loading your campaigns right now. Try refreshing the page, or{' '}
    <TextButton onClick={() => window?.adaEmbed?.toggle?.()}>reach out to support</TextButton> if
    the problem persists.
  </PlaceholderState>
);
